<template>
  <section class="left-container">
      <div class="left-content clearfix">
        <div class="mrg-btm-15 pad-top-15 clearfix">
          <dl v-for="(item, index) in navList" :key="`1-${index}`">
            <dt :class="{'active': type === item.value}">
              <router-link router-link :to="{'name': 'ViolationPublicity', query: {'type': item.value}}">{{item.label}}</router-link>
            </dt>
          </dl>
        </div>
      </div>
  </section>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      type: '1',
      navList: [
        {
          label: 'MP商家',
          value: '1'
        }
        // {
        //   label: '自营商家',
        //   value: '2'
        // }
      ]
    }
  },
  methods: {
    mountedFn () {
      this.type = this.$route.query.type || '1'
    }
  },
  watch: {
    $route (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.mountedFn()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.left-container {
  background: #fff;
  float: left;
  width: 238px;
  padding-left: 0;
  box-sizing: border-box;
  min-height: 520px;
  max-height: 700px;
  overflow: auto;
  .left-content {
    > div {
      // display: flex;
      // justify-content: space-between;
      // flex-wrap: wrap;
    }
    dl {
      flex: 0 0 33.33%;
      margin-bottom: 0px;
      &:nth-child(3n) {
        margin-right: 0px;
      }
      dt {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #333333;
        font-weight: 500;
        line-height: 40px;
        padding-left: 10px;
        border-left: 4px solid transparent;
        &.active {
          border-left: 4px solid #f10180;
          background: #f1f1f3;
        }
      }
      dd{
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #333333;
        font-weight: 400;
        line-height: 20px;
        margin-top: 16px;
      }
    }
  }
}
</style>
